import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthApiService, UserModel } from '@rillion/auth';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@rillion/store/auth';
import { Observable } from 'rxjs';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { AsyncPipe } from '@angular/common';
import { AppSettingsService } from '@rillion/core';

@Component({
  standalone: true,
  selector: 'app-user-detail-dialog',
  templateUrl: './user-detail-dialog.component.html',
  styleUrl: './user-detail-dialog.component.scss',
  imports: [MatDividerModule, MatRadioModule, AsyncPipe, TranslateModule],
})
export class UserDetailDialogComponent {
  readonly roles$ = this.store.select(AuthSelectors.selectRoles);
  readonly user$: Observable<UserModel> = this.store.select(AuthSelectors.selectUser);

  readonly logoutRedirectUrl = this.appSettingsService.appSettings.loginRedirectUrl + '/Logout.aspx';

  constructor(
    private dialogRef: MatDialogRef<UserDetailDialogComponent>,
    private readonly store: Store,
    private readonly appSettingsService: AppSettingsService,
    private authApiService: AuthApiService,
  ) {}

  onChange(change: MatRadioChange) {
    this.dialogRef.close(change.value);
  }

  logout() {
    //TODO: Implement logout
  }
}
